import $ from "jquery";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { DemandeParamTransfertDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeParamTransfertDto";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";
import { NatureTransfertEnum } from "../../dto/GenApi.iNotPaie.Dto/NatureTransfertEnum";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { RubriqueDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import ModalAjoutUpdateLibelle from "./modalAjoutUpdateLibelle/modalAjoutUpdateLibelle";

@Component({
    components: {
        ModalAjoutUpdateLibelle: require("./modalAjoutUpdateLibelle/modalAjoutUpdateLibelle.vue.html")
    },
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as LibellesComponent);
            vm.getParametres();
        });
    }
})
export default class LibellesComponent extends Vue {
    public libelles: ParametreDto[] = [];
    public libellesFiltred: ParametreDto[] = [];
    public typesParametrage: ParametreDto[] = [];
    public listeRubriques: RubriqueDto[] = [];

    public currentOrderColumn = "Libelle";
    public orderingDesc = true;

    public filterTypeLibelle = "AAMRC";
    public filterName = "";

    public dataReady = false;
    public displayArchives = false;

    public modalAjoutUpdateLibelle?: ModalAjoutUpdateLibelle = undefined;

    public canDoTransfert = false;

    public getParametres(): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }

        this.dataReady = false;
        ServicesFactoryInstance.ParametresService.getParametrageLibelles(data => {
            if (data != undefined) {
                this.libelles = data.ListeLibelles;
                this.typesParametrage = data.ListeTypesParametrage;
                this.listeRubriques = data.ListeRubriques;
                this.doFilter();
                this.getClassOfOrder(this.currentOrderColumn, true);
            }

            this.canDoTransfert = ParametresInstance.userIsCombinedAuthorized(["Administrateur", "AdministrateurPST"])
                && FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.TransfertSql);

            this.dataReady = true;
        }, () => {
            this.dataReady = true;
        });
    }

    public getClassOfOrder(columnName: string, desc: boolean): string {
        if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    public orderBy(columnName: string): void {
        if (this.currentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.currentOrderColumn = columnName;
        this.doOrder();
    }

    public doOrder(): void {
        const orderingDesc = this.orderingDesc;
        const columnName = this.currentOrderColumn;
        if (this.libellesFiltred != undefined) {
            this.libellesFiltred.sort(function (a, b) {

                // Gestion des valeurs null
                if (a[columnName] === null) {
                    return 1;
                }

                if (b[columnName] === null) {
                    return -1;
                }

                if (a[columnName] < b[columnName]) {
                    return (orderingDesc ? -1 : 1);
                }
                if (a[columnName] > b[columnName]) {
                    return (orderingDesc ? 1 : -1);
                }

                return 0;
            });
        }
    }

    public doFilter(): void {
        this.libellesFiltred = this.libelles.filter(s =>
        (
            this.displayArchives == s.EstArchive &&
            (
                (s.Libelle && s.Libelle.toUpperCase().includes(this.filterName.toUpperCase())) ||
                (s.Code && s.Code.toUpperCase().includes(this.filterName.toUpperCase()))
            ) && s.CodeCategorie == this.filterTypeLibelle
        )
        );

        this.doOrder();
    }

    public canAddOrArchive(): boolean {
        return this.filterTypeLibelle === 'SERVI' || ParametresInstance.userHasRole("Administrateur") || ParametresInstance.userHasRole("AdministrateurPST");
    }

    public ajouter(): void {
        let libellesCodeServices: ParametreDto[] = this.libelles.filter(l => l.CodeCategorie === this.filterTypeLibelle);

        if (this.modalAjoutUpdateLibelle == undefined) {
            this.modalAjoutUpdateLibelle = this.$refs.modalAjoutUpdateLibelle as ModalAjoutUpdateLibelle;
        }

        if (this.modalAjoutUpdateLibelle != undefined) {
            this.modalAjoutUpdateLibelle.Init(this.listeRubriques, this.filterTypeLibelle, libellesCodeServices, undefined);
        }

        $("#modalAjoutUpdateLibelle").modal("show");
    }

    public update(parametre: ParametreDto): void {
        if (parametre == undefined) {
            return;
        }

        if (this.modalAjoutUpdateLibelle == undefined) {
            this.modalAjoutUpdateLibelle = this.$refs.modalAjoutUpdateLibelle as ModalAjoutUpdateLibelle;
        }

        if (this.modalAjoutUpdateLibelle != undefined) {
            this.modalAjoutUpdateLibelle.Init(this.listeRubriques, this.filterTypeLibelle, [], parametre.Id);
        }

        $("#modalAjoutUpdateLibelle").modal("show");
    }

    public addLibelle(parametre: ParametreDto): void {
        if (parametre == undefined) {
            return;
        }

        this.libelles.push(parametre);
        this.doFilter();
        this.refreshInstance();
    }

    public updateLibelle(parametre: ParametreDto): void {
        if (parametre == undefined) {
            return;
        }

        this.libelles = this.libelles.filter(l => l.Id != parametre.Id);
        this.addLibelle(parametre);
    }

    public archiverLibelle(id: number): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment archiver ce libellé ?",
            callBackYes: () => {
                this.dataReady = false;
                ServicesFactoryInstance.ParametreService.archiverParametre(id, () => {
                    NotificationServiceInstance.SendSuccess("Libellé archivé avec succès.");

                    let libelleArchive = this.libelles.filter(l => l.Id == id)[0];
                    if (libelleArchive)
                        libelleArchive.EstArchive = true;

                    this.doFilter();
                    this.dataReady = true;
                    this.refreshInstance();
                }, () => {
                    this.dataReady = true;
                });
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    public refreshInstance(): void {
        if (this.filterTypeLibelle == "CABSC") {
            ParametresInstance.refreshListeTypesConges();
        }
    }

    public openModaleTransfert(libelle: ParametreDto): void {
        const modalTransfert: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Cette action va envoyer votre élément vers la liste d'attente des transferts SQL. Souhaitez-vous continuer ?",
            showDialog: true,
            title: "Confirmation",
            callBackYes: () => {
                this.transfertLibelle(libelle);
            }
        });

        EventBus.$emit(EventConstants.MODAL_ALERT, modalTransfert);
    }

    public transfertLibelle(libelle: ParametreDto): void {
        if (libelle !== undefined && libelle.Code !== undefined && libelle.CodeCategorie !== undefined) {
            const demande: DemandeParamTransfertDto = {
                Code: libelle.Code,
                CodeCategorie: libelle.CodeCategorie,
                Nature: NatureTransfertEnum.Libelle
            };

            ServicesFactoryInstance.EntiteEnAttenteService.addParametreToList(demande, () => {
                NotificationServiceInstance.SendSuccess("L'élément <strong>" + libelle.Libelle + "</strong> a bien été ajouté à la liste d'attente des transferts SQL.");
                this.dataReady = false;
                this.getParametres();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/libelles/libelles.ts